import { render, staticRenderFns } from "./EmailReportTab.vue?vue&type=template&id=15d7677e&"
import script from "./EmailReportTab.vue?vue&type=script&lang=ts&"
export * from "./EmailReportTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports